import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions'; // Import getFunctions

const firebaseConfig = {
    apiKey: process.env.REACT_APP_API_KEY || "AIzaSyBkpNFQlMTUI93wp9O0uTPUGUsF6rI4wV4",
    authDomain: process.env.REACT_APP_AUTH_DOMAIN || "admin-c78c6.firebaseapp.com",
    projectId: process.env.REACT_APP_PROJECT_ID || "admin-c78c6",
    storageBucket: process.env.REACT_APP_STORAGE_BUCKET || "admin-c78c6.firebasestorage.app",
    messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID || "439164090294",
    appId: process.env.REACT_APP_APP_ID || "1:439164090294:web:f9195d9a3d47a30f50f317"
};

let app;
let auth;
let db;
let storage;
let functions; // <-- Declare functions variable

try {
    app = initializeApp(firebaseConfig);
    auth = getAuth(app);
    db = getFirestore(app);
    storage = getStorage(app);
    
    // --- ADD THIS BLOCK ---
    // Initialize functions and connect to the correct region
    const region = 'us-central1'; // <-- Replace with your function's region if different
    functions = getFunctions(app, region);

} catch (e) {
    console.error("Firebase initialization error:", e);
}

export { auth, db, storage, app, functions }; // <-- Export functions